import type { Severity } from '@/types';

export type FixActionKey = 'repair' | 'replace' | 'further_inspection' | 'credit';

export interface FixActionDef {
  key: FixActionKey;
  label: string;
  showCredit: boolean;
  dotClass: string;
}

export const FIX_ACTIONS: FixActionDef[] = [
  { key: 'repair',             label: 'Repair',           showCredit: true,  dotClass: 'bg-brand' },
  { key: 'replace',            label: 'Replace',          showCredit: true,  dotClass: 'bg-brand-ink' },
  { key: 'further_inspection', label: 'Further inspect',  showCredit: false, dotClass: 'bg-sev-minor' },
  { key: 'credit',             label: 'Credit',           showCredit: true,  dotClass: 'bg-ink-muted' },
];

export const FIX_ACTION_BY_KEY: Record<FixActionKey, FixActionDef> =
  Object.fromEntries(FIX_ACTIONS.map(a => [a.key, a])) as Record<FixActionKey, FixActionDef>;

export interface FixFinding {
  id: string;
  sectionId: string;
  sectionTitle: string;
  indexLabel: string;
  title: string;
  description: string;
  severity: Severity;
  estimatedCost?: number;
  estimatedCostLow?: number;
  estimatedCostHigh?: number;
  /** AI mid-range; used as the credit-field placeholder. */
  creditMid?: number;
}

export type RecipientKind = 'inspector' | 'listing_agent';

export interface FixSelectionState {
  /** Current task step (1 = pick, 2 = actions, 3 = review). 4 = sent (no stepper). */
  step: 1 | 2 | 3 | 4;
  /** IDs of findings included in the fix list. */
  selected: Set<string>;
  /** Action chosen per finding. Defaults to 'repair' when first selected. */
  actions: Map<string, FixActionKey>;
  /**
   * Credit amount per finding. `undefined` means "use the placeholder
   * (AI mid-range)"; an explicit number — including 0 — means the user
   * typed a value.
   */
  credits: Map<string, number | undefined>;
  /** Where the fix list is going. Inspector is the default. */
  recipientKind: RecipientKind;
  /** Captured on Step 3 only when recipientKind === 'listing_agent'. */
  listingAgentName: string;
  listingAgentEmail: string;
}
